/**
 * كما في التقارير قبل إضافة `sep=,`: UTF-8 مع BOM فقط.
 * BOM (U+FEFF) يُشفَّر EF BB BF في بداية الملف فيُعرَف عادةً كـ UTF-8 في Excel والمحررات.
 */
export function createReportCsvBlob(csvBody) {
  return new Blob([`\uFEFF${csvBody}`], { type: 'text/csv;charset=utf-8' });
}
